module.exports = __webpack_public_path__ + "static/media/incorrect-relative.91576bf5.svg";